import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { brandConfiguration } from "@/brands/config";
import { DsaElement } from "@/components/utilsComponents";
import { Box } from "@gemini/core";
import { Link } from "@gemini/ui";
export const RentalLinkCustomFallback = () => {
    var _a, _b;
    const { rentalLink } = (_b = (_a = brandConfiguration === null || brandConfiguration === void 0 ? void 0 : brandConfiguration.ads) === null || _a === void 0 ? void 0 : _a.fallbacks) !== null && _b !== void 0 ? _b : {
        fallbacks: { rentalLink: "" },
    };
    const fallbackLinkClick = () => {
        // @ts-ignore
        window.open(rentalLink.url, "_blank");
    };
    return (_jsx(Box, { position: "relative", minHeight: "sizing.24", children: _jsxs(Box, { position: "absolute", zIndex: "zIndex.1", backgroundColor: "color.background.default", minHeight: "sizing.24", minWidth: "100%", display: "flex", children: [_jsx(Link
                // @ts-ignore
                , { 
                    // @ts-ignore
                    href: `#${rentalLink.label}`, onPress: fallbackLinkClick, variant: "standalone", marginRight: "spacing.12", children: rentalLink.label }), _jsx(DsaElement, {})] }) }));
};
